export default __webpack_public_path__ + "static/media/bkg--location-1.d2ecce65.jpg";